import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { AppStateFailureBuilder, AppStateFailureItemWithErrorCode, FailureType } from '@symphony-solo/shared/common-state/src';
import { ApiResponseCode } from '@symphony-solo/shared/http/src';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { HistoryService } from '../services';
import { GetOrderHistoryAction, GetOrderHistoryErrorAction, GetOrderHistorySuccessAction } from './history.actions';

@Injectable()
export class HistoryEffects {
  constructor(
    private action$: Actions,
    private historyService: HistoryService,
  ) {}


  protected getOrderHistory$ = createEffect(() =>
    this.action$.pipe(
      ofType(GetOrderHistoryAction),
      switchMap((RequestHistoryParams) => {
        return this.historyService.getAccountHistory(RequestHistoryParams.params).pipe(
          map((orderHistory) => GetOrderHistorySuccessAction({orderHistory} )),
          catchError(() => {
            const failure = new AppStateFailureBuilder()
              .setFailureType(FailureType.API)
              .addFailure(new AppStateFailureItemWithErrorCode('Error on getting order history', ApiResponseCode.Server_Error))
              .build();
            return of(GetOrderHistoryErrorAction({ failure }));
          })
        );
      })
    )
  );
    
}
